import styled from 'styled-components';
import ExpertIconComponent from '../expert-icon';

export const ExpertAvatar = styled.div`
  position: relative;
  height: fit-content;
`;

export const ExpertIcon = styled(ExpertIconComponent)`
  position: absolute;
  bottom: 0;
  right: 0;
`;
